import ActionTypes from "../../enums/ActionTypes"
import AppMode from "../../enums/AppMode"

const initialState = {
  mode: "",
}

export default (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SET_STANDARD_MODE: {
      return {
        ...state,
        mode: AppMode.Standard,
      }
    }
    case ActionTypes.SET_TERMINAL_MODE: {
      return {
        ...state,
        mode: AppMode.Terminal,
      }
    }
    case ActionTypes.SET_SCREEN_MODE: {
      return {
        ...state,
        mode: AppMode.Screen,
      }
    }
    default:
      return state
  }
}
